import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        globalThis.oneDataLayer.push({
            event: 'defaultPageView',
            pageName: document.title,
            url: globalThis.location.href,
            path: location.pathname,
        });
    }, [location]);
};
